<template>
  <div class="container alturaMinima">
    <embed src="/assets/files/pipma.pdf" type="application/pdf" width="100%" height="700px" />
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Política Institucional Para Médicos Adscritos - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Política Institucional Para Médicos Adscritos - QualityCare',
        content: 'Política institucional para médicos adscritos al Centro Audiológico y Quirúrgico del Country.',
      },
    ],
  },
  name: "Pipma",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
* {
  font-size: 1.3rem;
}

.container {
  background-color: #ffffff;
  padding-inline: 30px;
}
</style>
